import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { AlertComponent } from 'app/layout/common/alert/alert.component';
import { ButtonComponent } from 'app/layout/common/button/button.component';
import { CloseButtonComponent } from 'app/layout/common/button/close-button.component';
import { UserDialogViewModel } from './user-dialog.viewmodel';

@Component({
    selector: 'user-dialog',
    standalone: true,
    imports: [
        CloseButtonComponent,
        CommonModule,
        ReactiveFormsModule,
        MatDialogModule,
        MatFormFieldModule,
        MatInputModule,
        MatCheckboxModule,
        MatIconModule,
        AlertComponent,
        ButtonComponent
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './user-dialog.component.html',
    providers: [UserDialogViewModel]
})
export class UserDialogComponent implements OnInit {
    readonly vm = inject(UserDialogViewModel);

    ngOnInit(): void {
        this.vm.init();
    }
}
